import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps, PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';
import { Heading } from '@/components/common/Heading';

/**
 * Props for `StatsWithLogos`.
 */
export type StatsWithLogosProps =
  SliceComponentProps<Content.StatsWithLogosSlice>;

/**
 * Component for "StatsWithLogos" Slices.
 */
const StatsWithLogos: FC<StatsWithLogosProps> = ({ slice }) => {
  const { title, description, stats, logos } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-gradient-to-b from-[#0E1010] to-[#0F423A] py-20 text-white"
    >
      <div className="container mx-auto px-4 text-center">
        <Heading as="h2" size="xl" className="mb-4">
          <PrismicRichText field={title} />
        </Heading>
        <div className="mx-auto mb-12 max-w-2xl text-lg text-gray-300">
          <PrismicRichText field={description} />
        </div>

        {/* Stats Grid */}
        {stats && stats.length > 0 && (
          <div className="mx-auto mb-16 grid max-w-4xl grid-cols-2 gap-8 md:grid-cols-4">
            {stats.map((item, index) => (
              <div key={index} className="flex flex-col items-center">
                <p className="text-5xl font-bold text-white">{item.value}</p>
                <p className="mt-2 text-base text-gray-400">{item.label}</p>
              </div>
            ))}
          </div>
        )}

        {/* Logos */}
        {logos && logos.length > 0 && (
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8">
            {logos.map((item, index) => (
              <div key={index} className="flex-shrink-0">
                <PrismicNextImage
                  field={item.logo_image}
                  className="h-12 w-auto object-contain"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default StatsWithLogos;
